<template>
<div v-if="!initLoading && !loading" class="container-fluid new_Header">
    <nav class="nav_Breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item mx-2"><router-link  to="/">{{$t('maintenances.breadcrumb_1')}}</router-link></li>
        <i v-if="userLang" class="fa-solid fa-chevron-left pt-1"></i>
        <i v-else class="fa-solid fa-chevron-right pt-1"></i>
        <router-link to="/maintenance">
        <li class="mx-2 almarai-bold" aria-current="page">{{$t('maintenanceslist.breadcrumb_2')}}</li>
        </router-link>
        <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
        <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
        <li class="active mx-1 almarai-bold" aria-current="page">{{$t('maintenanceslist.breadcrumb_3')}}</li>
      </ol>
    </nav>
  </div>
  <div class="container pt-3">
    <div class="row">
      <div class="col">
        <!-- <div class="row pb-3">
          <router-link to="/maintenances">
            <div class="col btn-green">
              <span><i class="fa-solid fa-circle-plus"></i></span>
              <span class="mx-2">{{$t('maintenanceslist.title_1')}}</span>
            </div>
          </router-link>
        </div> -->

        <div>
          <errorAlert v-if="hasError || errorList" :alertMessage="message" 
            :errorNumber="errorNumber" 
          />
        </div>

        <div v-if="loading && initLoading" class="row justify-content-center">
          <div class="col text-center">
            <mainloader />
          </div>
        </div>
        
        <div v-else class="row">
          <div class="col">
            <div class="row py-2">
              <div class="col-12 col-md-8">
                <ul class="nav nav-tabs orders-ul" id="myTab" role="tablist">
                  <li class="nav-item"  role="presentation">
                    <div class="btn-radius active" 
                      id="home-tab" data-bs-toggle="tab" data-bs-target="#home-tab-pane" type="button" role="tab" 
                      aria-controls="home-tab-pane" aria-selected="true">
                      {{$t('maintenanceslist.title_4')}}
                    </div>
                  </li>
                  <li class="nav-item align-content-center" role="presentation">
                    <div class="btn-radius mx-2"  
                      id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile-tab-pane" type="button" role="tab" 
                      aria-controls="profile-tab-pane" aria-selected="false">
                      {{$t('maintenanceslist.title_5')}}
                    </div>
                  </li>
                </ul>
              </div>
              <div v-if="!initLoading && items.length" class="col-auto btn-green createOrder" data-bs-toggle="modal" data-bs-target="#exampleModal">
                <span><i class="fa-solid fa-circle-plus"></i></span>
                <span class="mx-2">{{$t('maintenanceslist.title_1')}}</span>
              </div>
            </div>

            <!-- begin:maintenance_Content -->
            <div class="tab-content pt-5" id="myTabContent">
              <!-- begin: currrent_Maintenance -->
              <div class="tab-pane fade show active" id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab" tabindex="0">
                <div class="row" v-if="!items.length && !loading">
                  <div class="col text-center">
                    <div class="text-center pb-3">
                      <!-- <img src="/assets/images/Frame-1.png" class="maintenancesLogo" alt=""> -->
                      <img src="/assets/images/icons/maintenance-logo.png" class="maintenanceLogo"  alt="">
                    </div>
                    <div>{{$t('myrequests.title_1')}}</div>
                    <div class="gray-color fonttext-14">{{$t('myrequests.title_2')}}</div>

                    <div class="row pt-3 justify-content-center">
                      <div class="col-auto btn-green" data-bs-toggle="modal" data-bs-target="#exampleModal">
                        <span><i class="fa-solid fa-circle-plus"></i></span>
                        <span class="mx-2">{{$t('maintenanceslist.title_1')}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="row mb-2 justify-content-center" v-for="(row, index) in items" :key="index">
                  <div class="col-12 col-md-7">
                    <router-link :to="'/maintenancedetails/'+row.id">
                      <div class="card maintenanceCard-16">
                        <div class="card-body">
                          <div class="row">
                            <div class="col">
                              <span class="code">{{$t('maintenanceslist.title_6')}} # {{row.id}}</span>
                            </div>
                            <div class="col-auto">
                              <div :class="(row.status == 'new')? 'status_Style status-New' : (row.status == 'done')? 'status_Style status-Done': (row.status == 'provier_canceled')? 'status_Style status-Cancel' : (row.status == 'client_canceled')? 'status_Style status-Cancel' :'status_Style status-New'" >
                                {{status[row.status]}}
                              </div>
                            </div>
                          </div>
                          <div class="almarai-bold">{{ row.title }}</div>
                          <div class="gray-colorAA pt-2">{{ row.description }}</div>
                          <!-- <div class="row">
                            <div class="col-auto">
                              <div v-if="row.image">
                                <img :src="MEDIA_URL+row.image" class="img-width" alt="">
                              </div>
                              <div v-else>
                                <img src="/assets/images/icons/img-settings.png"  alt="">
                              </div>
                            </div>
                            <div class="col">
                              <div class="almarai-bold">{{ row.title }}</div>
                              <div class="almarai-regular fonttext-14 gray-color">
                                {{row.description}}
                              </div>
                            </div>
                          </div> -->
                          <!-- <div class="row pt-3" v-if="row.Provider">
                            <div class="col-auto text-center">
                              <i class="bi bi-person font-36 pe-2"></i>
                            </div>
                            <div class="col">
                              <div class="almarai-regular">{{row.Provider.name}}</div>
                              <div class="almarai-regular gray-color">
                                {{row.Provider.mobile}}
                              </div>
                            </div>
                          </div> -->
                        </div>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
              <!-- end: currrent_Maintenance -->
              
              <!-- begin:completed_Maintenance -->
              <div class="tab-pane fade" id="profile-tab-pane" role="tabpanel" aria-labelledby="profile-tab" tabindex="0">
                <div  class="row mb-2 justify-content-center" v-for="(val,indx) in prevOrders" :key="indx">
                  <div class="col-12 col-md-8">
                      <div class="card">
                        <div class="card-body">
                          <div class="row">
                            <div class="col">
                              <div class="almarai-bold">{{ val.title }}</div>
                              <span class="code">{{$t('maintenanceslist.title_6')}} # {{val.id}}</span>
                            </div>
                            <div class="col-auto">
                              <div :class="(val.status == 'new')? 'status_Style status-New' : (val.status == 'done')? 'status_Style status-Done': (val.status == 'provier_canceled')? 'status_Style status-Cancel' : (val.status == 'client_canceled')? 'status_Style status-Cancel' :'status_Style status-New'" >
                                {{status[val.status]}}
                              </div>
                            </div>
                          </div>
                          <!-- <div class="row">
                            <div class="col-auto">
                              <div v-if="val.image">
                                <img :src="MEDIA_URL+val.image" class="img-width" alt="">
                              </div>
                              <div v-else>
                                <img src="/assets/images/icons/img-settings.png"  alt="">
                              </div>
                            </div>
                            <div class="col">
                              <div class="almarai-bold">{{ val.title }}</div>
                              <div class="almarai-regular fonttext-14 gray-color">
                                {{val.description}}
                              </div>
                            </div>
                          </div> -->
                          <div class="row py-2">
                            <div class="col">
                              <div class="card ratingCustomers">
                                <div class="card-body">
                                  <div class="row">
                                    <div class="col">
                                      {{$t('maintenanceslist.serviceRating')}}
                                    </div>
                                    <div class="col-auto">
                                      <div class="row">
                                        <div v-html="renderCustomer(val.rate)" class="col text-center">
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row orderDetails">
                            <div class="col underline">
                              <router-link :to="'/maintenancedetails/'+val.id">
                                {{$t('maintenanceslist.orderDetails')}}
                              </router-link>
                            </div>
                            <div class="col-auto">
                              <router-link class="btn-green" :to="'/maintenances/?orderT='+val.orderType+'&orderId='+val.id">
                                {{$t('maintenanceslist.re_Order')}}
                              </router-link>
                            </div>
                          </div>
                          <!-- <div class="row pt-3" v-if="val.Provider">
                            <div class="col-auto text-center">
                              <i class="bi bi-person font-36 pe-2"></i>
                            </div>
                            <div class="col">
                              <div class="almarai-regular">{{val.Provider.name}}</div>
                              <div class="almarai-regular gray-color">
                                {{val.Provider.mobile}}
                              </div>
                            </div>
                          </div> -->
                        </div>
                      </div>
                  </div>
                </div>
              </div>
              <!-- begin:completed_Maintenance -->
            </div>
            <!-- end:maintenance content -->
          </div>
        </div>
      </div>
    </div>

    <!-- Modal-begin:maintenances -->
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- <div class="modal-header">
            <button type="button" class="btn-close" id="maintenanceClose" data-bs-dismiss="modal" aria-label="Close"></button>
          </div> -->
          <div class="modal-body">

            <div class="row pt-3">
              <router-link to="/maintenances/?type=normal" @click="exitForm">
                <div class="col btn-black">
                  <div class=" almarai-bold">{{$t('requestMaintenance')}}</div>
                  <span class="text-center almarai-regular text-white">{{$t('Within_24hours')}}{{ normalOrderPrice }} {{$t('addAd.real')}}</span>
                </div>
              </router-link>
            </div>

            <div class="row pt-3">
              <router-link to="/maintenances/?type=fast" @click="exitForm">
                <div class="col btn-white">
                  <div class=" almarai-bold">{{$t('requestExpress_maintenance')}}</div>
                  <span class="text-center almarai-regular text-style">{{$t('Within_120Minutes')}}{{ fastOrderPrice }} {{$t('addAd.real')}}</span>
                </div>
              </router-link>
            </div>

            <div class="row pt-3">
              <router-link to="/maintenances/?type=mosque" @click="exitForm">
                <div class="col btn-white">
                  <div class="almarai-bold">{{$t('maintenanceMosques')}}</div>
                  <span class="text-center almarai-regular text-style">{{$t('godsMosques')}}</span>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal-end:maintenances -->

    <!--begin:modal login-->
    <div class="modal bg-modal" dir="rtl" tabindex="-1" id="formLogin">
      <div class="modal-dialog">
        <div class="modal-content">
          <button
            type="button"
            class="btn-close m-2"
            @click.prevent="closeingFN"
            id="modal-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
          <div class="modal-body">
            <div class="row justify-content-center">
              <div class="col text-center">
                <div class="font-24 almarai-bold">
                  {{$t("formLogin.title_1")}}
                </div>
                <p class="almarai-regular gray-color">
                  {{$t("formLogin.title_2")}} <br />
                  {{$t("formLogin.title_3")}}
                </p>
              </div>
            </div>
            <div class="row pt-3 justify-content-center">
              <div class="col-12 col-md-8 mb-2">
                <router-link to="/login">
                  <button
                    class="login-btn rounded-pill form-control almarai-bold"
                  >
                    {{$t("formLogin.title_4")}}
                  </button>
                </router-link>
              </div>
              <div class="col-12 col-md-8">
                <router-link to="/register">
                  <button class="form-control rounded-pill p-2 createAccount">
                    {{ $t("formLogin.title_5") }}
                  </button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:modal Login-->
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "maintenanceslist",
  data(){
    return{
      hasError: false,
      message: "",
      loading: true,
      initLoading: false,
      errorNumber: "",
      title: "",
      issueType: null,
      description: "",
      latitude: "",
      longitude: "",
      image: "",
      rows: [],
      items:[],
      status: {},
      errorList: false,
      prevOrders: [],
      userLang: 'ar',
      ratingValue: null,
      orderId: null,
      normalOrderPrice: 0,
      fastOrderPrice: 0,
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL', 'GET_USER'])
  },
  methods:{

    getDatainitial(){
      this.hasError = false;
      this.initLoading = true;
      this.$http.get("/api/orders/init").then(res => {
        // console.log(res);
        this.rows = res.data.issues;
        this.normalOrderPrice = res.data.normalOrderPrice;
        this.fastOrderPrice = res.data.fastOrderPrice;
        window.scroll(0,0);
        if(this.GET_USER){
          this.maintenanceList();
        }
        this.initLoading = false;
      }).catch(err => {
        // console.log(err);
        this.initLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scroll(0,0);
      });
    },

    maintenanceList(){
      this.errorList = false;
      this.loading = true;
      this.$http.get("/api/orders/list").then(res => {
        // console.log(res);
        this.items = res.data.currentOrders;
        this.status = res.data.orderStatus;
        this.prevOrders = res.data.previousOrders;
        this.loading = false;
      }).catch(err => {
        // console.log(err);
        this.loading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.errorList = true;
      });
    },


    renderCustomer(ratingCustomer) {
      const max = 5;
      let container = '<div>';
      // console.log(container);
      // console.log(rating);
      
      for (let i = 1; i <= max; i++) {
        container += '<i ';
      // full star
      if (ratingCustomer >= i) {
        container += 'class="fa-solid fa-star bg-star" aria-hidden="true"';
      }
      // half star (e.g. rating = 3.5 -> when i=4, rating >= 3.5)
      else if (ratingCustomer >= i - 0.5) {
        container += 'class="fa-solid fa-star-half-alt bg-star" aria-hidden="true"';
      }
      // empty star
      else {
        container += 'class="far fa-star fonttext-14" aria-hidden="true"';
      }
      container += '></i>';
      }
      container += '</div>';
      return container;
    },

    exitForm(){
      const modal = bootstrap.Modal.getInstance(
        document.getElementById('exampleModal')
      );
      modal.hide();
    },

    closeingFN() {
      document.getElementById("formLogin").style.display = "none";
    },

    poupLogin(){
      document.getElementById("formLogin").style.display = "block";
    },


  },
  created(){
    this.getDatainitial();
    this.userLang = localStorage.getItem('lang') ?? 'ar';
    // if(window.getComputedStyle(rowument.getElementById("mobNavBtn"),null).getPropertyValue('display') == 'block' && window.getComputedStyle(rowument.getElementById("navbarNavDropdown"),null).getPropertyValue('display') == 'block'){
    //   rowument.getElementById("mobNavBtn").click();
    // }
  }
}
</script>